export { withControlledFormComponentValue } from './with-controlled-form-component-value';
